// Copyright ID Business Solutions Ltd. 2023

import { useIntlMessage } from '@idbs/idbs-react-hooks';
import { ConfirmDialog } from '@idbs/idbs-react-components';
import React from 'react';

type ImportErrorDialogProperties = {
  onClose: () => void;
};

const ImportErrorDialog = ({ onClose }: ImportErrorDialogProperties) => {
  const intlMessage = useIntlMessage();
  const title = intlMessage('app.import.failed');
  const header = intlMessage('app.import.failed.reason');
  const body = intlMessage('app.import.failed.response');
  const closeText = intlMessage('app.import.failed.cancel');
  return (
    <ConfirmDialog
      body={body}
      header={header}
      onClose={onClose}
      icon='attention'
      title={title}
      closeBtnText={closeText}
      submitBtnText=''
      submitBtnPosition='right'
      visible={true}
      testId='import-error-dialog'
    />
  );
};

export { ImportErrorDialog };
